export default function getGraphCmsImageUrl(coverImage, width = 720) {
  return coverImage && `https://eu-central-1.graphassets.com/AdWP6bwOSW6lzZmkceBSFz/resize=w:${width}/${coverImage.handle}`;
}
